<template>
    <div class="chart-container">
        <div class="stat-chart" id="stat-chart" v-if="type === 'stat-chart'"></div>
        <div class="rate-chart" ref="rate-chart" v-else-if="type === 'rate-chart'"></div>
    </div>
</template>

<script>
import Core from "core/core";
import echarts from "echarts";
import { Chart } from '@antv/g2';
// import REGION from '@/assets/ext/region-code.json';
import i18n from '../../../locales/index'

export default {
    components: {},
    props: {
        type: String,
        default: "",
    },
    data() {
        return {
            zh: true,
            useChart: null,
            echart: null,
            txt: {
	            Normal: '',
	            Warning: '',
	            Abnormal: '',
	            shutdown: '',
	            offline: '',
	            deviceNum: '',
            },
            consume: {
                count: '',                  // 设备总数
                consumed_this_month: '',    // 月消耗量
                consumed_this_year: '',     // 年消耗量
                need_add_count: '',         // 补充量
                total_count: '',            // 总润滑剂
                availability: '',           // 可用率
	            shutdown_count: '',         // 关闭数
                alarm_count: '',            // 告警数
                exception_count: '',        // 异常数
                normal_count: '',           // 正常数
                offline_count: '',          // 离线数
            },
        }
    },
    watch: {},
    computed: {},
    created() {
        this.initTxt()
    },
    mounted() {
        this.getDeviceList()
        console.log("type", this.type)
    },
    methods: {
        initTxt(){
	        this.lang = localStorage.getItem('skf.data.lang')
	        this.zh = this.lang === '"zh"'
	        this.txt.Normal =  i18n.t('chart.Normal')
	        this.txt.Warning = i18n.t('chart.Warning')
	        this.txt.Abnormal = i18n.t('chart.Abnormal')
	        this.txt.deviceNum = i18n.t('chart.deviceNum')
	        this.txt.Availability = i18n.t('chart.Availability')
	        this.txt.shutdown = i18n.t('chart.shutdown')
	        this.txt.offline = i18n.t('chart.offline')
	        console.log (this.zh)
        },
        getDeviceList() {
            Core.Api.Device.getDeviceList().then((res)=>{
                this.consume = res;
                let keys = ['shutdown_count', 'alarm_count', 'exception_count', 'normal_count'];
                let offline_count = res.total_count || 0;

                keys.forEach(key=>{
                    offline_count -= res[key] || 0;
                })
                this.consume.offline_count = offline_count;
                if(this.type === "stat-chart") {
                    this.deviceChart();
                } else if(this.type === "rate-chart") {
                    this.deviceUseRate();
                }
            })
        },
	    // initRegion() {
        //     let list = REGION.zh
		//     list.map(province => {
		// 	    province.children.map(city => delete city.children)
		//     })
		//     this.regionData = list
	    // },
        deviceChart() {
            let that = this;
            var data = [
                {
	                type: this.txt.Normal + ":" + this.consume.normal_count,          //正常
	                // type: this.consume.normal_count + '\n' +this.txt.Normal,          //正常
                    value: this.consume.normal_count
                }, 
                {
                    type: this.txt.Warning+ ":" + this.consume.alarm_count,          //告警
                    // value: this.consume.exception_count
	                value: this.consume.alarm_count
                },
                {
                    type: this.txt.Abnormal+ ":" + this.consume.exception_count,          //异常
                    value: this.consume.exception_count
                }, 
                {
                    type: this.txt.shutdown+ ":" + this.consume.shutdown_count,          //关闭
	                value: this.consume.shutdown_count
                }, 
                {
                    type: this.txt.offline+ ":" + this.consume.offline_count,          //离线
	                value: this.consume.offline_count
                }
            ];
            var sum = this.consume.total_count;
            // var ds = new DataSet();
            // var dv = ds.createView().source(data);
            // dv.transform({
            //     type: 'map',
            //     callback: function callback(row) {
            //         row.value = parseInt(sum * row.percent);
            //         return row;
            //     }
            // });
	        var chart
            let config = {
                container: 'stat-chart',
                forceFit: true,
                height: 170,
                padding: 'auto'
            }
            if (!this.zh) {
                config.height = 190;
            }
            chart = new Chart(config);
            if (!chart) {
	            console.log('不支持chart')
            }
	        chart.source(data);
            chart.tooltip(false);
            chart.legend({
                position: 'bottom-center',
                itemFormatter: (row,data)=> {
                    return row
                }
                // offsetX: -100
            });
            chart.coord('theta', {
                radius: 0.85,
                innerRadius: 0.76
            });
            chart.intervalStack().position('value')
            .color('type', ['#88c008', '#ffd615', '#ec202a', '#99a5aa', '#606266'])
                .opacity(1)
                // .label('percent', {
                //     offset: 12,
                //     textStyle: {
                //         fill: 'black',
                //         fontSize: 9,
                //         shadowBlur: 0,
                //         shadowColor: 'rgba(0, 0, 0, .45)'
                //     },
                //     rotate: 0,
                //     autoRotate: false,
                //     formatter: function formatter(text, item) {
                //         return item.point.type +':' + item.point.value;
                //     }
                // });
            chart.guide().html({
                position: ['50%', '50%'],
                html: 
                    `<div class="g2-guide-html" style='width:56px' ref='g2-guide-html'>
                        <p class="title" style='font-size: 12px;color: #8E9AAD;text-align: center;line-height: 12px;'>${this.txt.deviceNum}</p>
                        <p class="value" style='font-size: 18px;color: #363D42;text-align: center;margin-top:5px;line-height: 14px;font-weight:500;'>${sum}</p>
                    </div>`
            });
            chart.on('interval:mouseenter', function(ev) {
                var data = ev.data._origin;
                let guide = document.getElementsByClassName('g2-guide-html')[0];
                    guide.style.opacity = 1;
                    guide.querySelector('.title').innerHTML = data.type;
                    guide.querySelector('.value').textContent = data.value;
            });

            chart.on('interval:mouseleave', function() {
                let guide = document.getElementsByClassName('g2-guide-html')[0];
                guide.querySelector('.title').textContent = that.txt.deviceNum;
                guide.querySelector('.value').textContent = sum;
            });
            chart.render();
            this.$emit("getConsume", this.consume)
        },
        deviceUseRate() {
            let that = this;
            // console.log("==", this.consume)
            let num = Number(this.consume.availability * 100);
            num > 0 ? num = num.toFixed(2) : num = 0
            this.useChart = echarts.init(this.$refs['rate-chart']);
            let colorArr = ['#0f58d6','#0f58d6','#0f58d6'];
            let currArr = '#0f58d6'
            if(num < 80) {
                currArr = colorArr[2]
            }else if(num < 90 && num >=80) {
                currArr = colorArr[1]
            }else {
                currArr = '#0f58d6'
            }
            let useOption = {
                tooltip : {
                    formatter: "{a} <br/>{b} : {c}%"
                },
                series: [
                    {
                        name: this.txt.Availability,
                        type: 'gauge',
                        // detail: {formatter:'{value}%'},
                        axisLabel: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: [
                                    [num/100,currArr],
                                    [1,'#F0F2F5']
                                ],
                                width: 14
                            }
                        },
                        itemStyle: {

                        },
                        title: {
                            offsetCenter: [
                                0,'90%'
                            ],
	                        fontSize: '12',
                            color: '#8E9AAD'
                        },
                        detail: {
                            offsetCenter: [
                                0,'60%'
                            ],

	                        fontSize: '12',
                            formatter: function (value) {
                                return value + '%';
                            },
                            fontWeight: 'bold'
                        },
                        pointer: {
                            length: '60%'
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        data: [{value: num, name: this.txt.Availability}]
                    }
                ]
            }
            this.useChart.setOption(useOption);
            window.addEventListener("resize", function () {
                // that.echart.resize();
                that.useChart.resize();
            });
        },
    },
}
</script>

<style lang='scss' scoped>
</style>
